import { DisabledUser } from "../types/disabled-user.definition";
import { UnverifiedUser } from "../types/unverified-user.definition";
import { UserProfileDetails } from "../types/user.definition";
import {
  UpdateUserSettingsPayload,
  UserSettings,
} from "../types/userSettings.definition";
import {
  getDisabledUsers,
  getUnverifiedUsers,
  getUserById,
  getUserSettings,
  reactivateUser,
  updateUserProfileImage,
  updateUserSettings,
  verifyUser,
} from "../webclients/user.client";

export const userApi = {
  getDisabledUsers: async (): Promise<DisabledUser[]> => {
    const response = await getDisabledUsers();
    return response.data;
  },
  reactivateUser: async (id: number): Promise<DisabledUser> => {
    const response = await reactivateUser(id);
    return response.data;
  },
  getUnverifiedUsers: async (): Promise<UnverifiedUser[]> => {
    const response = await getUnverifiedUsers();
    return response.data;
  },
  verifyUser: async (id: number): Promise<UnverifiedUser> => {
    const response = await verifyUser(id);
    return response.data;
  },
  getUserById: async (userId: string): Promise<UserProfileDetails> => {
    const response = await getUserById(userId);
    return response.data;
  },
  updateProfileImage: async (
    userId: string,
    photoUrl: string
  ): Promise<UserProfileDetails> => {
    const response = await updateUserProfileImage(userId, photoUrl);
    return response.data;
  },
  getUserSettings: async (userId: string): Promise<UserSettings> => {
    const response = await getUserSettings(userId);
    return response.data;
  },
  updateUserSettings: async (
    userId: string,
    data: UpdateUserSettingsPayload
  ): Promise<UserSettings> => {
    const response = await updateUserSettings(userId, data);
    return response.data;
  },
};

export default userApi;
